import { Person } from 'types';
import { CalibrationViewSummary } from '../types';

/**
 * Determines if a person is the owner or an administrator of a calibration view.
 * @param person - The person to check
 * @param view - The calibration view summary
 * @returns true if the person is the owner or an administrator, false otherwise
 */
export function isOwnerOrAdmin(
  person: Person | null | undefined,
  view: CalibrationViewSummary | null | undefined
): boolean {
  if (!person || !view) {
    return false;
  }

  // Check if user is the owner
  if (view.ownerPerson?.id === person.id) {
    return true;
  }

  // Check if user is an administrator
  if (view.administrators?.some((admin) => admin.id === person.id)) {
    return true;
  }

  return false;
}

/**
 * Determines if a person is the owner of a calibration view.
 * @param person - The person to check
 * @param view - The calibration view summary
 * @returns true if the person is the owner, false otherwise
 */
export function isOwner(
  person: Person | null | undefined,
  view: CalibrationViewSummary | null | undefined
): boolean {
  if (!person || !view) {
    return false;
  }

  return view.ownerPerson?.id === person.id;
}

/**
 * Determines if a calibration view is Live.
 * @param view - The calibration view summary
 * @returns true if the view status is 'L' (Live), false otherwise
 */
export function isLive(
  view: CalibrationViewSummary | null | undefined
): boolean {
  return view?.status === 'L';
}
